export async function ipLookup() {
    try {
        const response = await fetch('/api/ip-lookup/', {
            headers: {
                Accept: 'application/json',
            },
        });

        const body = await response.json();

        if (!response.ok) {
            throw new Error(body.message);
        }

        return body;
    } catch (_err) {
        return null;
    }
}

export async function isAbuser() {
    if (localStorage.getItem('simulate_is_abuser') === '1') {
        return true;
    }

    const result = await ipLookup();

    return !!result?.isAbuser;
}
